const initState = {};

export default (state = initState, actions) => {
    return state;
};
